(function (global) {
  var STORAGE_KEY = "ck_wishlist_v1";
  var BUTTON_SELECTOR = "[data-wishlist-button]";
  var GRID_SELECTOR = "[data-wishlist-grid]";
  var LOADING_SELECTOR = "[data-wishlist-loading]";
  var EMPTY_SELECTOR = "[data-wishlist-empty]";
  var CARD_FRAGMENT_SELECTOR = "[data-wishlist-card-fragment]";
  var initialized = false;

  function normalizeHandles(value) {
    if (!Array.isArray(value)) return [];

    return value.reduce(function (handles, item) {
      var handle = typeof item === "string" ? item.trim() : "";

      if (handle !== "" && handles.indexOf(handle) === -1) {
        handles.push(handle);
      }

      return handles;
    }, []);
  }

  function readWishlist(storage) {
    try {
      var rawValue = storage.getItem(STORAGE_KEY);

      if (rawValue == null || rawValue === "") {
        return [];
      }

      return normalizeHandles(JSON.parse(rawValue));
    } catch (error) {
      return [];
    }
  }

  function writeWishlist(storage, handles) {
    var nextHandles = normalizeHandles(handles);

    try {
      storage.setItem(STORAGE_KEY, JSON.stringify(nextHandles));
    } catch (error) {
      return false;
    }

    return true;
  }

  function toggleHandle(storage, handle) {
    var cleanHandle = typeof handle === "string" ? handle.trim() : "";
    var handles = readWishlist(storage);
    var index = handles.indexOf(cleanHandle);
    var added = false;

    if (cleanHandle === "") {
      return { added: false, handles: handles };
    }

    if (index === -1) {
      handles.push(cleanHandle);
      added = true;
    } else {
      handles.splice(index, 1);
    }

    writeWishlist(storage, handles);

    return { added: added, handles: handles };
  }

  function buildCardUrl(handle) {
    return "/products/" + encodeURIComponent(handle) + "?view=card";
  }

  function findCardFragment(parsedDocument) {
    if (!parsedDocument || typeof parsedDocument.querySelector !== "function") {
      return null;
    }

    return parsedDocument.querySelector(CARD_FRAGMENT_SELECTOR);
  }

  function parseCardFragment(html, Parser) {
    if (!Parser) return null;

    try {
      return findCardFragment(new Parser().parseFromString(html, "text/html"));
    } catch (error) {
      return null;
    }
  }

  function syncButton(button, handles, options) {
    var handle = button.dataset.wishlistHandle;
    var isActive = handles.indexOf(handle) !== -1;
    var label = isActive ? button.dataset.wishlistRemoveLabel : button.dataset.wishlistAddLabel;
    var status = isActive ? button.dataset.wishlistAddedStatus : button.dataset.wishlistRemovedStatus;
    var visibleLabel = button.querySelector("[data-wishlist-label]");
    var screenReaderLabel = button.querySelector("[data-wishlist-sr-label]");
    var statusLabel = button.querySelector("[data-wishlist-status]");

    button.classList.toggle("is-active", isActive);
    button.setAttribute("aria-pressed", isActive ? "true" : "false");

    if (visibleLabel && label) {
      visibleLabel.textContent = label;
    }

    if (screenReaderLabel && label) {
      screenReaderLabel.textContent = label;
    }

    if (statusLabel) {
      statusLabel.textContent = options && options.announce ? status || "" : "";
    }
  }

  function syncButtons(root) {
    var scope = root || global.document;
    var storage = global.localStorage;

    if (!scope || !storage || typeof scope.querySelectorAll !== "function") {
      return;
    }

    var handles = readWishlist(storage);

    scope.querySelectorAll(BUTTON_SELECTOR).forEach(function (button) {
      syncButton(button, handles, { announce: false });
    });
  }

  function updateMatchingButtons(handle, handles, announce) {
    if (!global.document) return;

    global.document.querySelectorAll(BUTTON_SELECTOR).forEach(function (button) {
      if (button.dataset.wishlistHandle === handle) {
        syncButton(button, handles, { announce: announce });
      }
    });
  }

  function dispatchWishlistUpdated(button, result) {
    if (!global.document || typeof global.CustomEvent !== "function") return;

    global.document.dispatchEvent(new global.CustomEvent("ck:wishlist-updated", {
      bubbles: true,
      detail: {
        handle: button.dataset.wishlistHandle || "",
        productId: button.dataset.wishlistProductId || "",
        variantId: button.dataset.wishlistVariantId || "",
        source: button.dataset.wishlistSource || "",
        context: button.dataset.wishlistContext || "",
        added: result.added,
        handles: result.handles.slice()
      }
    }));
  }

  function handleButtonClick(event) {
    var button = event.target.closest && event.target.closest(BUTTON_SELECTOR);

    if (!button || !button.dataset.wishlistHandle) return;

    event.preventDefault();

    var result = toggleHandle(global.localStorage, button.dataset.wishlistHandle);

    updateMatchingButtons(button.dataset.wishlistHandle, result.handles, true);
    dispatchWishlistUpdated(button, result);
  }

  function updateProductVariant(event) {
    var variantId = event && event.detail && event.detail.variant && event.detail.variant.id;

    if (!variantId || !global.document) return;

    global.document.querySelectorAll(BUTTON_SELECTOR + "[data-wishlist-context=\"product\"]").forEach(function (button) {
      button.dataset.wishlistVariantId = String(variantId);
    });
  }

  function setElementHidden(element, hidden) {
    if (element) {
      element.hidden = hidden;
    }
  }

  function appendFragmentContents(grid, fragment) {
    var children = Array.prototype.slice.call(fragment.children || []);

    children.forEach(function (child) {
      grid.appendChild(child);
    });

    return children.length;
  }

  function fetchCardFragment(handle, options) {
    var fetcher = options.fetcher;
    var Parser = options.Parser;

    if (typeof fetcher !== "function" || typeof Parser !== "function") {
      return Promise.resolve(null);
    }

    return fetcher(buildCardUrl(handle), { credentials: "same-origin" })
      .then(function (response) {
        if (!response || !response.ok) return null;
        return response.text();
      })
      .then(function (html) {
        return html ? parseCardFragment(html, Parser) : null;
      })
      .catch(function () {
        return null;
      });
  }

  function hydrateWishlistPage() {
    if (!global.document) return;

    var grid = global.document.querySelector(GRID_SELECTOR);

    if (!grid || grid.dataset.wishlistInitialized === "true") return;

    grid.dataset.wishlistInitialized = "true";

    var loading = global.document.querySelector(LOADING_SELECTOR);
    var empty = global.document.querySelector(EMPTY_SELECTOR);
    var handles = readWishlist(global.localStorage);

    grid.innerHTML = "";

    if (handles.length === 0) {
      setElementHidden(loading, true);
      setElementHidden(empty, false);
      return;
    }

    setElementHidden(loading, false);
    setElementHidden(empty, true);

    var queue = handles.slice();
    var activeRequests = 0;
    var renderedCount = 0;
    var concurrency = 3;

    function next() {
      if (queue.length === 0 && activeRequests === 0) {
        setElementHidden(loading, true);
        setElementHidden(empty, renderedCount > 0);
        syncButtons(grid);
        return;
      }

      while (activeRequests < concurrency && queue.length > 0) {
        activeRequests += 1;

        fetchCardFragment(queue.shift(), {
          fetcher: global.fetch,
          Parser: global.DOMParser
        }).then(function (fragment) {
          if (fragment) {
            renderedCount += appendFragmentContents(grid, fragment);
            syncButtons(grid);
          }
        }).finally(function () {
          activeRequests -= 1;
          next();
        });
      }
    }

    next();
  }

  function observeAsyncSurfaces() {
    if (!global.MutationObserver || !global.document || !global.document.body) return;

    var observer = new global.MutationObserver(function (mutations) {
      mutations.forEach(function (mutation) {
        mutation.addedNodes.forEach(function (node) {
          if (node.nodeType !== 1) return;

          if (node.matches && node.matches(BUTTON_SELECTOR)) {
            syncButtons(node.parentNode || global.document);
          } else if (node.querySelector && node.querySelector(BUTTON_SELECTOR)) {
            syncButtons(node);
          }
        });
      });
    });

    observer.observe(global.document.body, { childList: true, subtree: true });
  }

  function initWishlist() {
    if (initialized || !global.document) return;

    initialized = true;

    global.document.addEventListener("click", handleButtonClick);
    global.document.addEventListener("variant:change", updateProductVariant);

    syncButtons(global.document);
    hydrateWishlistPage();
    observeAsyncSurfaces();
  }

  function onReady() {
    if (!global.document) return;

    if (global.document.readyState === "loading") {
      global.document.addEventListener("DOMContentLoaded", initWishlist, { once: true });
    } else {
      initWishlist();
    }
  }

  var api = {
    STORAGE_KEY: STORAGE_KEY,
    selectors: {
      button: BUTTON_SELECTOR,
      grid: GRID_SELECTOR,
      loading: LOADING_SELECTOR,
      empty: EMPTY_SELECTOR,
      cardFragment: CARD_FRAGMENT_SELECTOR
    },
    normalizeHandles: normalizeHandles,
    readWishlist: readWishlist,
    writeWishlist: writeWishlist,
    toggleHandle: toggleHandle,
    buildCardUrl: buildCardUrl,
    findCardFragment: findCardFragment,
    parseCardFragment: parseCardFragment,
    init: initWishlist
  };

  global.CKWishlist = api;

  if (typeof module !== "undefined" && module.exports) {
    module.exports = api;
  }

  onReady();
})(typeof window !== "undefined" ? window : globalThis);
